import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithBoxNewPassword() {
	return <AuthShell variant="with-box"><AuthForm variant="with-box" mode="new-password" /></AuthShell>;
}

export default AuthWithBoxNewPassword;
